module.exports = __webpack_public_path__ + "img/loading.f40bb2e6.svg";